export const ADDRESS_STEP = 'address';
export const RECEPTION_STEP = 'reception';
export const PAYMENT_STEP = 'payment';
export const PRIVACY_STEP = 'privacy';

export const SALUTATION_FEMALE = 'female';
export const SALUTATION_MALE = 'male';
